import React, { useEffect, useState } from "react";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAtom } from "jotai";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { useCurrentRole } from "../../_helper/constant/Permission";
import {
  useCreateItem,
  useUpdateItem,
} from "../../_helper/actions/mutation/items";
import CuSpinner from "../../common_component/component/CuSpinner";
import "../css/patientDetailsCardSm.css";
import { toast } from "react-toastify";
import { IoMdAdd } from "react-icons/io";
import { getImageURL } from "../../_helper/utils/image";
import moment from "moment";
import CuTooltip from "../../common_component/component/CuTooltip";
import { FaHeart, FaRegHeart } from "react-icons/fa6";

const PatientDetailsCardSm = ({ profile_image, isFavorite }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const userId = searchParams.get("userId");
  const slotId = searchParams.get("slotId");
  const bill_id = searchParams.get("bill_id");
  const [clinic] = useAtom(clinicAtom);
  const { role_id } = useCurrentRole();
  const { doctor_personal_details } = useCurrentRole();

  const [isfavorite, setIsFavorite] = useState(isFavorite);

  //(isFavorite);

  const patchDoctorDetails = useUpdateItem(
    `${ApiEndPoint?.USERS}doctor_personal_detail/`,
    ApiEndPoint?.CLINIC
  );

  const handleFavoritePatient = (id, action) => {
    const payload = {
      action: "patchDoctorPersonalDetails",
      id: doctor_personal_details?.id,
      clinic_id: clinic?.id,
      backend: "True",
      special_patient: [userId],
      special_patient_action: action === "add" ? "add" : "remove",
    };

    patchDoctorDetails.mutate(
      { id: null, data: payload },
      {
        onSuccess: (data) => {
          if (action === "add") {
            setIsFavorite(true);
            toast.success("Marked as a Special Patient");
          } else {
            setIsFavorite(false);
            toast.success("Patient Unmarked");
          }
          // refetch();
        },
        onError: (err) => {
          toast.error(err.response.data.message);
        },
      }
    );
  };

  const { data: userDetails, isLoading: userLoading } = useItemsFilter(
    ApiEndPoint.USERS,
    `?action=getUserDetails&backend=True&clinic_id=${clinic?.id}&id=${userId}`,
    clinic?.id && userId ? true : false
  );

  const postConsultation = useCreateItem(ApiEndPoint.QP_CM_CONSULTATION_DATA);

  const handleStartConsultation = () => {
    if (!slotId) {
      toast.error("Please book appointment first");
      return;
    }
    const payload = {
      action: "postConsultationData",
      frontend: "True",
      transaction_type: "OPD",
      clinic_id: clinic?.id,
      doctor_user: role_id,
      personal_details: userId,
      opd_date: moment.utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
      slot_id: slotId,
      feature_name: "consultation",
    };
    postConsultation.mutate(payload, {
      onSuccess: (data) => {
        // if (data?.data?.id) {
        //   navigate(
        //     `/new/consultation?userId=${userId}&slotId=${slotId}&consultationId=${data?.data?.id}&option=ongoingconsultation`
        //   );
        //   localStorage.setItem(
        //     "ongoing_consultations",
        //     JSON.stringify([
        //       `/new/consultation?userId=${userId}&slotId=${slotId}&consultationId=${data?.data?.id}`,
        //     ])
        //   );
        // } else {
        //   navigate(
        //     `/new/consultation?userId=${userId}&slotId=${slotId}&consultationId=${data?.consultation_id}&option=ongoingconsultation`
        //   );
        //   localStorage.setItem(
        //     "ongoing_consultations",
        //     JSON.stringify([
        //       `/new/consultation?userId=${userId}&slotId=${slotId}&consultationId=${data?.consultation_id}`,
        //     ])
        //   );
        // }
        if (data?.data?.id) {
          navigate(
            `/new/patient-options?userId=${userId}&slotId=${slotId}&bill_id=${bill_id}&consultationId=${data?.data?.id}&option=ongoingconsultation`
          );
          localStorage.setItem(
            "ongoing_consultations",
            JSON.stringify([
              `/new/patient-options?userId=${userId}&slotId=${slotId}&bill_id=${bill_id}&consultationId=${data?.data?.id}&option=ongoingconsultation`,
            ])
          );
        } else {
          navigate(
            `/new/patient-options?userId=${userId}&slotId=${slotId}&bill_id=${bill_id}&consultationId=${data?.consultation_id}&option=ongoingconsultation`
          );
          localStorage.setItem(
            "ongoing_consultations",
            JSON.stringify([
              `/new/patient-options?userId=${userId}&slotId=${slotId}&bill_id=${bill_id}&consultationId=${data?.consultation_id}&option=ongoingconsultation`,
            ])
          );
        }
      },
      onError: (err) => {
        toast.error(err.response.data.message);
      },
    });
  };

  //(isfavorite);

  useEffect(() => {
    setIsFavorite(isFavorite);
  }, [isFavorite]);

  return (
    <>
      <div className="flex flex-col p-3 gap-6">
        <div className="cu-patient-details-sm-main">
          <div className="cu-patient-details-sm-profile border">
            {userDetails?.length > 0 && !userDetails[0]?.profile_image ? (
              <div className="bg-[#C7EAC9] text-4xl font-bold rounded w-full h-full uppercase text-white flex justify-center items-center">
                {userDetails?.length > 0 ? userDetails[0]?.full_name[0] : ""}
              </div>
            ) : (
              <img
                className="w-full h-full rounded"
                src={
                  userDetails?.length > 0
                    ? getImageURL(userDetails[0]?.profile_image)
                    : ""
                }
                alt="..,"
              />
            )}
          </div>

          <div className="cu-patient-details-sm-info">
            <div className="cu-patient-details-sm-full-name">
              {userDetails?.length > 0 ? userDetails[0]?.full_name : "-"}
            </div>
            <div className="cu-patient-details-sm-other-data">
              <span className="cu-patient-details-sm-other-data-label">
                Mobile Number
              </span>
              <span className="cu-patient-details-sm-other-data-text">
                {userDetails?.length > 0 ? userDetails[0]?.phone : "-"}
              </span>
            </div>
          </div>

          {/* Special Patient  */}

          <div className="flex justify-end ml-auto pr-3">
            <div
              onClick={() =>
                handleFavoritePatient(userId, isfavorite ? "remove" : "add")
              }
              className="cursor-pointer"
            >
              {isfavorite ? (
                <FaHeart
                  className="text-2xl ml-3 align-middle"
                  style={{ color: "#77db8f" }}
                />
              ) : (
                <FaRegHeart
                  className="text-2xl ml-3 align-middle"
                  style={{ color: "#77db8f" }}
                />
              )}
            </div>
          </div>
        </div>
        <div className="cu-patient-details-sm-btn-container">
          <button className="flex items-center justify-center gap-[11px] text-[#6d6d6d] bg-[#f2fbf3] rounded-md text-[16px] h-[48px] min-w=[180px] font-bold py-[15px] px-[28px]">
            <span>
              <IoMdAdd />
            </span>
            <span>Appointment</span>
          </button>
          <button
            className="flex items-center justify-center gap-[11px] text-[#6d6d6d] bg-[#f2fbf3] rounded-md text-[16px] h-[48px] min-w=[180px] font-bold py-[15px] px-[28px]"
            onClick={handleStartConsultation}
          >
            {postConsultation.isLoading ? (
              <CuSpinner />
            ) : (
              <>
                <span>
                  <IoMdAdd />
                </span>
                <span>Prescription</span>
              </>
            )}
          </button>
          <button className="flex items-center justify-center gap-[11px] text-[#6d6d6d] bg-[#f2fbf3] rounded-md text-[16px] h-[48px] min-w=[180px] font-bold py-[15px] px-[28px]">
            <span>
              <IoMdAdd />
            </span>
            <span>Document</span>
          </button>
          <button className="flex items-center justify-center gap-[11px] text-[#6d6d6d] bg-[#f2fbf3] rounded-md text-[16px] h-[48px] min-w=[180px] font-bold py-[15px] px-[28px]">
            <span>
              <IoMdAdd />
            </span>
            <span>Forms</span>
          </button>
          <button className="flex items-center justify-center gap-[11px] text-[#6d6d6d] bg-[#f2fbf3] rounded-md text-[16px] h-[48px] min-w=[180px] font-bold py-[15px] px-[28px]">
            <span>
              <IoMdAdd />
            </span>
            <span>Refer</span>
          </button>
          <button className="flex items-center justify-center gap-[11px] text-[#6d6d6d] bg-[#f2fbf3] rounded-md text-[16px] h-[48px] min-w=[180px] font-bold py-[15px] px-[28px]">
            <span>
              <IoMdAdd />
            </span>
            <span>Notes</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default PatientDetailsCardSm;
